import EAssessmentMediaBrowserDirectiveControllerCk5 from './EAssessmentMediaBrowserDirectiveControllerCk5';
import registerEAssessmentMediaBrowserDirectiveCk5 from './EAssessmentMediaBrowserDirectiveCk5';

/**
 * Registers all CMS components with the Angular application
 * @param {Object} angular - The Angular instance
 */
export default function registerCMSComponents(angular) {
    // Get module references
    const directivesModule = angular.module('assessmentFrontendDirectives');

    // Register controller
    directivesModule.controller('EAssessmentMediaBrowserDirectiveControllerCk5', EAssessmentMediaBrowserDirectiveControllerCk5);

    // Register directive
    registerEAssessmentMediaBrowserDirectiveCk5(directivesModule);
} 